import styled from 'styled-components';

export default styled.div`
	--bb-color: var(--neutrals-200);
	--bb-background: transparent;
	--bb-radius: var(--px-8);
	background-color: var(--bb-background);
	border-radius: var(--bb-radius);
	border: var(--px-1) solid var(--bb-color);
`;
